import { useLanguage } from '../../../contexts/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer id="footer" className="relative py-16 bg-gradient-to-r from-red-900 via-red-700 to-red-600 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-transparent to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://static.readdy.ai/image/78b249b905e2bab988df960bca6da6fd/60ff3a18dd5605b1f76c7856e3032bde.png"
                alt="ComiAI Logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white/90 text-sm leading-relaxed mb-6">
              {t(
                '融合AI技术与东方文化，打造新一代数字内容创作与情感交互平台',
                'Integrating AI technology with Eastern culture to create next-generation digital content creation and emotional interaction platforms'
              )}
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-base mb-4">{t('产品', 'Products')}</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  onClick={() => window.REACT_APP_NAVIGATE('/aicomic')}
                  className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  {t('AI漫画生成器', 'AI Comic Generator')}
                </a>
              </li>
              <li>
                <a 
                  onClick={() => window.REACT_APP_NAVIGATE('/emotional-ai')}
                  className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  {t('AI治愈宠物', 'AI Healing Pet')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-base mb-6">{t('公司', 'Company')}</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  onClick={() => {
                    window.REACT_APP_NAVIGATE('/');
                    setTimeout(() => {
                      const element = document.getElementById('overview');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  {t('关于我们', 'About Us')}
                </a>
              </li>
              <li>
                <a 
                  onClick={() => {
                    window.REACT_APP_NAVIGATE('/');
                    setTimeout(() => {
                      const element = document.getElementById('team');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  {t('团队', 'Team')}
                </a>
              </li>
              <li>
                <a 
                  onClick={() => {
                    window.REACT_APP_NAVIGATE('/');
                    setTimeout(() => {
                      const element = document.getElementById('vision');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  {t('我们的愿景', 'Our Vision')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-base mb-6">{t('联系我们', 'Contact Us')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-lg text-white/80 mt-0.5"></i>
                <div className="text-white/80 text-sm space-y-1">
                  <p>{t('香港数码港道100号数码港二座智能空间2号', 'Smart Space 2, Cyberport 2, 100 Cyberport Road, Hong Kong')}</p>
                  <p>{t('深圳市南山区南山智园C2栋16层', 'Floor 16, Building C2, Nanshan Intelligent Park, Nanshan District, Shenzhen')}</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-lg text-white/80 mt-0.5"></i>
                <a href="mailto:comiai_talent@outlook.com" className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer">
                  comiai_talent@outlook.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-lg text-white/80 mt-0.5"></i>
                <a href="tel:+85257469338" className="text-white/80 text-sm hover:text-white transition-colors cursor-pointer">
                  +852 5746 9338
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/70 text-sm">
              {t('© 2025 ComiAI科技。保留所有权利。', '© 2025 ComiAI Technology. All rights reserved.')}
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">
                {t('隐私政策', 'Privacy Policy')}
              </a>
              <a href="#" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">
                {t('服务条款', 'Terms of Service')}
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
